/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Row, Col,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function IdentifierFieldset(props) {
  const { arrayHelpers, t } = props;

  const handleAddIdentifier = () => {
    arrayHelpers.push({ label: '', code: '' });
  };

  const jsx = (
    <FormikConsumer>
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values,
      }) => (
        <div>
          <Button color="primary" onClick={() => handleAddIdentifier(arrayHelpers)} className="btn-sm mt-3 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Identifier')}
          </Button>
          <Button color="primary" onClick={() => arrayHelpers.push({ label: 'UPC', code: '' })} className="btn-sm mt-3 mb-3 ms-2">
            <span className="bx bx-plus" />
            {props.t('Add UPC')}
          </Button>
          {errors.identifiers !== undefined && typeof errors.identifiers === 'string' && (
            <ErrorMessage
              name="identifiers"
              component="div"
              className="alert alert-danger fade show mt-2 mb-3"
            />
          )}
          {values && values.identifiers && values.identifiers.map((identifier, index) => (
            <div key={index}>
              <Row className="mb-3">
                <Col xs="6">
                  <InputGroup>
                    <Field name={`identifiers[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                    <Button
                      type="button"
                      onClick={() => arrayHelpers.remove(index)}
                      color="danger"
                      className="btn-soft-danger"
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  </InputGroup>
                  <ErrorMessage
                    name={`identifiers[${index}].label`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>

                <Col xs="6">
                  <Field name={`identifiers[${index}].code`} type="text" className="form-control" placeholder={t('Code')} />
                  <ErrorMessage
                    name={`identifiers[${index}].code`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

IdentifierFieldset.defaultProps = {
  t: (x) => (x),
};

IdentifierFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(IdentifierFieldset));
